// extracted by mini-css-extract-plugin
export default {"main":"side_main__maBUz","profileContainer":"side_profileContainer__SsmxY"};